import { trpc } from '@/shared/api';

interface DesignQueryOptions {
  readonly enabled: boolean;
}

/** 내 디자인 한 건(designs.get). 로그인 상태에서만 켠다 — activeProcedure 라 비로그인은 UNAUTHORIZED 다. */
export const useDesignQuery = (designId: string | null, options: DesignQueryOptions) =>
  trpc.designs.get.useQuery(
    { id: designId ?? '' },
    { enabled: options.enabled && designId !== null && designId.length > 0, retry: false },
  );
